import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import './ModalNavHeader.scss';
import Button from '../Button';
import { getTranslation } from '../../providers/TranslationProvider';

const ModalNavHeader = (props) => {
  const {
    label,
    onCloseIconPress,
    onBackIconPress,
    showDivider,
  } = props;

  return (
    <div className={cx('ModalNavHeader', {
      showDivider,
    })}
    >
      <div className="ModalNavHeader__Wrapper">
        {onBackIconPress ? (
          <div className="grid_col">
            <Button variant="back" data-test-id="modal-nav-button-back" onClick={onBackIconPress} />
          </div>
        ) : <div />}
        <h1 className="grid_col label" data-test-id="modal-nav-label">{label}</h1>
        {onCloseIconPress ? (
          <div className="grid_col ModalNavHeader__close">
            <Button
              className="ModalNavHeader__dismiss-button"
              aria-label={getTranslation({
                translationKey: 'close',
                fallback: 'Close',
              })}
              data-test-id="modal-nav-button-close"
              onClick={onCloseIconPress}
              variant="close"
            />
          </div>
        ) : <div />}
      </div>
    </div>
  );
};

ModalNavHeader.propTypes = {
  label: PropTypes.string,
  onCloseIconPress: PropTypes.func,
  onBackIconPress: PropTypes.func,
  showDivider: PropTypes.bool,
};

ModalNavHeader.defaultProps = {
  label: undefined,
  onCloseIconPress: undefined,
  onBackIconPress: undefined,
  showDivider: true,
};

ModalNavHeader.displayName = 'ModalNavHeader';
export default ModalNavHeader;
